import { _keys, } from '../util/data';
import { _$id, _addEventListener, } from '../util/dom';
import { _addKeyHandlers, } from '../service/key-handlers';
const _viewMode = 0, _addMode = 1, _removeMode = 2, _cutMode = 3, _modes = {
    view: _viewMode,
    add: _addMode,
    remove: _removeMode,
    cut: _cutMode,
}, _modeKeys = {
    v: 'view',
    a: 'add',
    r: 'remove',
    c: 'cut',
}, _modeKeyList = _keys(_modeKeys), _setModeFromClick = (clickEvent) => {
    const $input = clickEvent.target, modeName = $input.value;
    if (!modeName) {
        return;
    }
    _setMode(modeName);
}, _setModeFromKeyup = (keyupEvent) => {
    const modeName = _modeKeys[keyupEvent.key];
    if (!modeName) {
        return;
    }
    const $modeButton = _$id(`rm-mode-${modeName}`);
    $modeButton.click();
}, _setMode = (modeName) => {
    _currentModeCell = _modes[modeName];
    document.body.setAttribute('data-map-mode', modeName);
}, _setInitialMode = () => {
    _$initialModeInput.click();
}, _currentMode = () => _currentModeCell, _initialMode = _viewMode, _$modesControl = _$id('rm-modes'), _$initialModeInput = _$id('rm-mode-view');
let _currentModeCell = _initialMode;
_setInitialMode();
_addEventListener(_$modesControl, 'click', _setModeFromClick);
_addKeyHandlers(_modeKeyList, _setModeFromKeyup);
export { _currentMode, _viewMode, _addMode, _removeMode, _cutMode, };
